!-- * UIID: UI-DLB-MAP-150 * UI Name: Scanner Version History * Modify Date: 2020/05/21 -->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    :options="options"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="popup-history"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text" primary-title>
        {{ $t('lbl.mapManager.scannerVersionHistory.header') }}
      </v-card-title>
      <!-- [E]  Popup title-->
    </template>
    <template v-slot:button-close>
      <!-- <v-icon small class="mr-2" @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-card class="analyzed-dialog matched-map-list-dialog">
      <!-- [S]  Popup top text-->
      <v-card-text class="pb-0 popup-title pb-0">
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0">
            <span class="title-file-name--text">{{ scannerName }}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [S]  Popup top text-->

      <!-- [S]  Popup top buttons-->
      <v-card-text class="top-btn-display-m">
        <v-row class="ma-0">
          <v-col cols="12" class="pb-0 pt-0">
            <v-btn
              class="btn btn-popup-search float-right mr-1"
              color="primary"
              tile
              dark
              @click="openCheckIn"
              v-if="this.options.item.action != 'scannerbuilder'"
            >
              <!-- <v-icon small color="white" class="mr-1">fa fa-check-circle</v-icon> -->
              {{ $t('btn.mapManager.checkIn') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup top buttons-->

      <!-- [S]  Popup body-->
      <v-card-text class="content-version-section">
        <v-row class="content-covering-m pt-0">
          <v-col cols="12" class="pa-0">
            <v-row class="version-history-table ma-0">
              <v-col cols="12" class="pa-0">
                <v-data-table
                  :items="scannerList"
                  :hide-default-footer="true"
                  :fixed-header="true"
                  class="analyzed-layout-table"
                  disable-pagination
                  disable-sort
                  :height="customHeight"
                >
                  <template v-slot:body="{ items }">
                    <thead>
                      <tr>
                        <th class="text-center text-version" style="width:51px">
                          {{ $t('tbl.mapManager.versionHistory.ver') }}
                        </th>
                        <th class="text-center text-version" colspan="2" style="width:117px">
                          {{ $t('tbl.mapManager.versionHistory.select') }}
                        </th>
                        <th class="text-center text-version" style="width:133px">
                          {{ $t('tbl.mapManager.versionHistory.date') }}
                        </th>
                        <th class="text-center text-version">
                          {{ $t('tbl.mapManager.versionHistory.user') }}
                        </th>
                        <th class="text-center text-version">
                          {{ $t('tbl.mapManager.versionHistory.changeHistory') }}
                        </th>
                        <th v-if="isDlb === true" class="text-center text-version">
                          {{ $t('tbl.mapManager.versionHistory.executeFile') }}
                        </th>
                        <th class="text-center text-version" style="width:60px">
                          {{ $t('tbl.mapManager.versionHistory.delete') }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in items" :key="item.id">
                        <td class="text-center text-bold">{{ item.SCAN_VER }}</td>
                        <td
                          v-if="item.CURVER_YN === 'Y'"
                          class="text-left  align-radio"
                          style="width:29px"
                        >
                          <input
                            type="radio"
                            v-model="item.CURVER_YN"
                            :value="item.CURVER_YN"
                            name="matched-map"
                            @click="selectVersion(item)"
                          />
                        </td>
                        <td
                          v-if="item.CURVER_YN === 'N'"
                          class="text-left  align-radio"
                          style="width:29px"
                        >
                          <input type="radio" name="matched-map" @click="selectVersion(item)" />
                        </td>
                        <td class="text-left" style="width:87px">
                          <a @click="openCheckOut(item)">{{
                            $t('tbl.mapManager.versionHistory.checkOut')
                          }}</a>
                        </td>
                        <td class="text-left">{{ item.CRE_DT }}</td>
                        <td class="text-left text-bold">{{ item.CRE_USR }}</td>
                        <td class="text-left">{{ item.CHKIN_COMT }}</td>
                        <td v-if="isDlb === true" class="text-left" style="width:87px">
                          <a @click="downloadFiOb(item)">{{
                            $t('tbl.mapManager.versionHistory.download')
                          }}</a>
                        </td>
                        <td class="text-center">
                          <v-btn
                            v-if="item.CURVER_YN === 'Y'"
                            small
                            disabled
                            text
                            icon
                            @click="deleteItem(item)"
                          >
                            <icon-svg :disabled="true" iconName="delete" />
                          </v-btn>
                          <v-btn
                            v-if="item.CURVER_YN === 'N'"
                            small
                            text
                            icon
                            @click="deleteItem(item)"
                          >
                            <icon-svg iconName="delete" />
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">{{ $t('btn.common.reset') }}</v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup body-->

      <v-divider class="ml-0 mr-0 divder-popup" inset></v-divider>
      <v-row class="ml-0 mr-0">
        <v-col class="button-col action-col" lg="12">
          <div class="btn-form-control text-right">
            <v-btn class="btn btn-delete btn-popup" @click="removeDialog">
              {{ $t('btn.common.close') }}
            </v-btn>
            <v-btn
              class="btn btn-popup-search btn-popup"
              color="primary"
              tile
              dark
              @click="saveVersionHistory"
              v-if="this.options.item.action != 'scannerbuilder'"
              :disabled="oldVersion === currentSelect.MAPP_VER"
            >
              <!-- <v-icon small color="white" class="mr-1">fa fa-save</v-icon> -->
              {{ $t('btn.common.save') }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <dialogWindow
      ref="warningDialog"
      size="max"
      :detail="$t('msg.common.warning.detailWarningCheckIn')"
      color="warning"
    >
    </dialogWindow>
    <dialogWindow
      ref="checkOutDialog"
      size="max"
      :detail="$t('msg.common.warning.detailOkConfirm')"
      color="confirmation"
      show-cancel="true"
      @select-close="onClickCancel"
      @select-ok="onClickOkay"
    >
    </dialogWindow>
    <dialogWindow
      ref="deleteDialog"
      size="max"
      :detail="$t('msg.common.infoConfirm.detail', ['delete the scanner'])"
      color="confirmation"
      show-cancel="true"
      @select-ok="onClickDelete"
    >
    </dialogWindow>
    <dialogWindow
      ref="successDialog"
      size="max"
      :detail="$t('msg.common.deploySuccess', ['Scanner version'])"
      color="success"
      @select-ok="onClickSave"
    >
    </dialogWindow>
    <dialogWindow
      ref="downloadFail"
      size="max"
      :detail="$t('msg.common.warning.notFindTargetFile')"
      color="warning"
    >
    </dialogWindow>
    <dialogWindow
      ref="moveMapbuilder"
      size="max"
      :detail="$t('msg.common.warning.moveConfirm', [this.scannerName])"
      color="confirmation"
      show-cancel="true"
      @select-ok="onClickMove"
    >
    </dialogWindow>
    <dialogWindow
      ref="warningCheckedOutDialog"
      size="max"
      :detail="$t('msg.common.warning.detailWarningIsCheckedOut', ['scanner', updateUserId])"
      color="validation"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
/* globals Store */
import { mapState } from 'vuex';

import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
/* 2020/11/06 203737 Remove unused source
import controlData from '../Data/asset-creation/data_control.json';*/
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { DownloadFile } from '@/vue-dlb/models/DownloadFile';
import cfg from '@/vue-caas/config/config.js';
// 2021.12.06 SPKA-304 svg icon
import IconSvg from '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    DialogDrag,
    dialogWindow,
    IconSvg,
  },
  /* 2020/10/29 203737 Change prop definitions
    props: ['id', 'title', 'options', 'eventCb', 'selectFile', 'closeDialog', 'dragStart', 'dragEnd', 'fileSelected', 'dialogCheckIn', 'versionList','reFreshList'],*/
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    dialogCheckIn: Function,
    versionList: Object,
    reFreshList: Function,
  },
  name: 'flatFile-layout-list',
  data: () => ({
    fileId: null,
    scannerName: '',
    warningDialog: false,
    checkOutDialog: false,
    /* 2020/11/06 203737 Remove unused source
      selectedDelete: null,*/
    lockedFlag: false,
    successDialog: false,
    downloadDialog: false,
    downloadFail: false,
    moveMapbuilder: false,
    scannerData: [],
    /* 2020/11/06 203737 Remove unused source
      map_table_header : controlData[0].flatFile_version_table_header,
      map_table_data : controlData[0].flatFile_version_table_data,*/
    versionHistoryItems: {
      header: ['MAP_PRCS_NO'],
      data: [
        {
          MAP_PRCS_NO: '',
        },
      ],
    },
    currentVerItems: {
      header: ['MAP_KIND', 'MAP_PRCS_NO', 'MAP_HST_NO', 'FILE_ID', 'CODE_CTG_ID'],
      data: [
        {
          MAP_KIND: '',
          MAP_PRCS_NO: '',
          MAP_HST_NO: '',
          FILE_ID: '',
          CODE_CTG_ID: '',
        },
      ],
    },
    lockItems: {
      header: ['MAP_KIND', 'MAP_PRCS_NO', 'LOCK_YN'],
      data: [
        {
          MAP_KIND: '',
          MAP_PRCS_NO: '',
          LOCK_YN: '',
        },
      ],
    },
    deleteItems: {
      header: ['MAP_KIND', 'MAP_PRCS_NO', 'MAP_HST_NO', 'FILE_ID'],
      data: [
        {
          MAP_KIND: '',
          MAP_PRCS_NO: '',
          MAP_HST_NO: '',
          FILE_ID: '',
        },
      ],
    },
    /* 2020/11/06 203737 Remove unused source
      viewFileItems: {
        header: ['FILE_ID'],
        data: [{
          FILE_ID: ''
        }]
      },*/
    isDlb: false,
    isCheckedOut: false,
    updateUserId: '',
    oldVersion: '',
    currentSelect: {},
    customHeight: 70,
  }),
  created() {
    this.isDlb = cfg.isDlb;
    this.scannerName = this.versionList.SCANNER_NAME;
    this.queryList();
    this.isCheckedOut = this.options.item.data.isCheckedOut;
    this.updateUserId = this.options.item.data.MAP_UPD_USR;
  },
  computed: {
    ...mapState('map', {
      scannerList: 'scannerList',
    }),
    ...mapState('common', {
      fileContent: 'fileContent',
    }),
  },
  methods: {
    queryList() {
      this.versionHistoryItems.data[0].MAP_PRCS_NO = this.versionList.MAP_PRCS_NO;
      Store.dispatch('map/queryScannerHistoryList', this.versionHistoryItems).then(() => {
        console.log('--------- Finished to process ----------');
        this.currentSelect = this.scannerList.find((e) => e.CURVER_YN === 'Y');
        let len = this.scannerList.length;
        this.customHeight = (len > 6 ? 6 : len + 1) * 35;
        this.oldVersion = this.currentSelect.SCAN_VER;
      });
    },
    saveVersionHistory() {
      if (this.currentVerItems.data[0].MAP_HST_NO == '') {
        let filtered = data.filter((item) => item.CURVER_YN === 'Y');
        this.currentVerItems.data[0].MAP_HST_NO = filtered[0].HST_NO + '';
      }
      this.currentVerItems.data[0].MAP_KIND = 'SCAN';
      this.currentVerItems.data[0].MAP_PRCS_NO = this.versionList.MAP_PRCS_NO;
      this.currentVerItems.data[0].CODE_CTG_ID = this.versionList.CODE_CTG_ID;
      Store.dispatch('map/saveCurrentVer', this.currentVerItems).then(() => {
        console.log('--------- Finished to process ----------');
        this.$refs.successDialog.dialog = true;
        this.queryList();
      });
    },
    viewFile() {
      Store.dispatch('common/viewFileData', this.fileId.FILE_ID).then(() => {
        console.log('--------- Finished view File ----------');
        this.scannerData = [];
        this.scannerData.push(this.fileContent);
        this.scannerData.push(this.fileId);
        //this.$emit('scannerData',scannerData);
      });
    },
    viewFileMoveMapBuilder(data) {
      Store.dispatch('common/viewFileData', this.fileId.FILE_ID).then(() => {
        // console.log("--------- Finished view File ----------");
        const query = new URLSearchParams({
          mapId: this.versionList.MAP_PRCS_NO,
          ver: this.currentSelect.SCAN_VER,
          flag: 'Y',
          tab: 'Scanner',
        }).toString();
        this.removeDialog({});
        window.open(`/transformation/mapbuilder?${query}`);
      });
    },
    selectVersion(item) {
      this.currentSelect = item;
      this.currentVerItems.data[0].MAP_HST_NO = item.HST_NO + '';
      this.currentVerItems.data[0].FILE_ID = item.FILE_ID;
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    /* 2020/10/28 203737 Remove unused source
      selectFlatFile (item){
        this.removeDialog({});
        this.selectFile(item);
      },*/
    onClickSave() {
      this.reFreshList();
      this.removeDialog({});
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    /* 2020/10/28 203737 Remove unused source
      findIndexItem(item, arr, col) {
        let prop = (typeof col == 'undefined') ? 'id' : col;
        let index = arr.findIndex((row) => {
          return row[prop] === item[prop]
        })
        return (index > -1) ? index : null
      },*/
    openCheckIn() {
      if (this.versionList.MAP_SCAN_CHKIN_YN === 'N' && this.lockedFlag === false) {
        this.$refs.warningDialog.dialog = true;
        return;
      }
      if (this.isCheckedOut) {
        this.$refs.warningCheckedOutDialog.dialog = true;
        return;
      }
      this.dialogCheckIn();
    },
    openCheckOut(item) {
      this.fileId = item;
      this.$refs.checkOutDialog.dialog = true;
    },
    downloadFiOb(item) {
      let downloadfile = new DownloadFile();
      if (item.TARGET_FILE_ID === '' || item.TARGET_FILE_ID === null) {
        this.$refs.downloadFail.dialog = true;
      } else {
        downloadfile.data[0].FILE_ID = item.TARGET_FILE_ID;
        downloadfile.data[0].SAVE_NAME = item.TARGET_FILE_NAME;
        Store.dispatch('common/DownloadFileFromServer', downloadfile).then(() => {
          console.log('--------- Finished to process ----------');
        });
      }
    },
    // downloadFife(){
    //   let downloadfile = new DownloadFile();
    //   downloadfile.data[0].FILE_ID = this.fileId.FILE_ID;
    //   downloadfile.data[0].SAVE_NAME = this.versionList.SCANNER_NAME;

    //   Store.dispatch("common/DownloadFileFromServer", downloadfile).then(() => {
    //     console.log("--------- Finished to process ----------");
    //   });
    // },
    onClickOkay() {
      if (this.isCheckedOut) {
        this.$refs.warningCheckedOutDialog.dialog = true;
        return;
      }
      this.lockItems.data[0].MAP_KIND = 'SCAN';
      this.lockItems.data[0].MAP_PRCS_NO = this.versionList.MAP_PRCS_NO;
      this.lockItems.data[0].LOCK_YN = 'Y';

      Store.dispatch('map/updateLock', this.lockItems).then(() => {
        console.log('--------- Finished to process CHECKOUT ----------');
        this.lockedFlag = true;
        this.reFreshList();
        if (this.options.item.action == 'scannerbuilder') {
          this.viewFile();
          //  this.downloadFife();
        } else {
          // this.downloadFife();
        }
      });
      this.$refs.moveMapbuilder.dialog = true;
    },
    onClickCancel() {
      // if(this.options.item.action !='scannerbuilder'){
      //    this.downloadFife();
      // }
      this.$refs.moveMapbuilder.dialog = true;
    },
    onClickMove() {
      this.viewFileMoveMapBuilder();
      this.$refs.moveMapbuilder.dialog = false;
    },
    deleteItem(item) {
      this.seletedDelete = item;
      this.$refs.deleteDialog.dialog = true;
    },
    onClickDelete() {
      let item = this.seletedDelete;
      this.deleteItems.data[0].MAP_KIND = 'SCAN';
      this.deleteItems.data[0].MAP_PRCS_NO = this.versionList.MAP_PRCS_NO;
      this.deleteItems.data[0].MAP_HST_NO = item.HST_NO;
      this.deleteItems.data[0].FILE_ID = item.FILE_ID;
      Store.dispatch('map/deleteSelectedHistory', this.deleteItems).then(() => {
        this.queryList();
        console.log('--------- Finished to process ----------');
      });
    },
  },
};
</script>

<style>
.tab-text {
  padding-left: 5px !important;
  justify-content: left !important;
}
.v-tabs.theme--dark > .v-item-group {
  background-color: #424242 !important;
}
.v-tabs.theme--dark > .v-item-group > .v-window.v-item-group {
  background-color: #424242 !important;
}
.analyzed-layout-dialog
  .v-text-field.search-matched-map-list-button
  .v-input__control
  .v-input__slot {
  width: 190px;
  margin: 0px !important;
}
.analyzed-layout-dialog .search-button {
  margin: 0px !important;
}
.analyzed-layout-table a {
  font-weight: bold;
  text-decoration: underline;
  color: #0082ba !important;
}
.analyzed-layout-table table td {
  font-weight: normal !important;
  font-size: 11px !important;
}
.analyzed-layout-table thead {
  border-top: 1px solid #d0d4dd !important;
}

.v-text-field__slot .top-btn-display-m {
  padding: 0px !important;
}
.text-version,
.analyzed-layout-table table td.text-bold {
  font-weight: 600 !important;
  font-size: 11px;
  line-height: 15px;
}
.version-history-table {
  max-width: 750px;
}
.version-history-table .v-data-table__wrapper {
  background: #fafcff;
  overflow-x: hidden;
}
</style>
